import {
  createOperationGroup as publicCreateOperationGroup,
  getOperationGroup as publicGetOperationGroup,
  updateOperationGroup as publicUpdateOperationGroup,
  deleteOperationGroup as publicDeleteOperationGroup,
  queryOperationGroups as publicQueryOperationGroups,
  typedQueryOperationGroups as publicTypedQueryOperationGroups,
  bulkCreateOperationGroups as publicBulkCreateOperationGroups,
  bulkUpdateOperationGroups as publicBulkUpdateOperationGroups,
  bulkDeleteOperationGroups as publicBulkDeleteOperationGroups,
  bulkUpdateOperationGroupTags as publicBulkUpdateOperationGroupTags,
  bulkUpdateOperationGroupTagsByFilter as publicBulkUpdateOperationGroupTagsByFilter,
} from './restaurants-v1-operation-group-operation-groups.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  OperationGroupQuery,
  OperationGroupsQueryBuilder,
  typedQueryOperationGroups as universalTypedQueryOperationGroups,
} from './restaurants-v1-operation-group-operation-groups.universal.js';
import { onOperationGroupCreated as publicOnOperationGroupCreated } from './restaurants-v1-operation-group-operation-groups.public.js';
import { onOperationGroupDeleted as publicOnOperationGroupDeleted } from './restaurants-v1-operation-group-operation-groups.public.js';
import { onOperationGroupUpdated as publicOnOperationGroupUpdated } from './restaurants-v1-operation-group-operation-groups.public.js';

function customQueryOperationGroups(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryOperationGroups(httpClient)(),
    typedQueryFunction: (query: OperationGroupQuery) =>
      publicTypedQueryOperationGroups(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): OperationGroupsQueryBuilder;
  function overloadedQuery(
    query: OperationGroupQuery
  ): ReturnType<typeof universalTypedQueryOperationGroups>;
  function overloadedQuery(query?: OperationGroupQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createOperationGroup: MaybeContext<
  BuildRESTFunction<typeof publicCreateOperationGroup> &
    typeof publicCreateOperationGroup
> = /*#__PURE__*/ createRESTModule(publicCreateOperationGroup);
export const getOperationGroup: MaybeContext<
  BuildRESTFunction<typeof publicGetOperationGroup> &
    typeof publicGetOperationGroup
> = /*#__PURE__*/ createRESTModule(publicGetOperationGroup);
export const updateOperationGroup: MaybeContext<
  BuildRESTFunction<typeof publicUpdateOperationGroup> &
    typeof publicUpdateOperationGroup
> = /*#__PURE__*/ createRESTModule(publicUpdateOperationGroup);
export const deleteOperationGroup: MaybeContext<
  BuildRESTFunction<typeof publicDeleteOperationGroup> &
    typeof publicDeleteOperationGroup
> = /*#__PURE__*/ createRESTModule(publicDeleteOperationGroup);
export const bulkCreateOperationGroups: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateOperationGroups> &
    typeof publicBulkCreateOperationGroups
> = /*#__PURE__*/ createRESTModule(publicBulkCreateOperationGroups);
export const bulkUpdateOperationGroups: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateOperationGroups> &
    typeof publicBulkUpdateOperationGroups
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateOperationGroups);
export const bulkDeleteOperationGroups: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteOperationGroups> &
    typeof publicBulkDeleteOperationGroups
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteOperationGroups);
export const bulkUpdateOperationGroupTags: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateOperationGroupTags> &
    typeof publicBulkUpdateOperationGroupTags
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateOperationGroupTags);
export const bulkUpdateOperationGroupTagsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateOperationGroupTagsByFilter> &
    typeof publicBulkUpdateOperationGroupTagsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateOperationGroupTagsByFilter);
export const queryOperationGroups: MaybeContext<
  BuildRESTFunction<typeof customQueryOperationGroups> &
    typeof customQueryOperationGroups
> = /*#__PURE__*/ createRESTModule(customQueryOperationGroups);
/** */
export const onOperationGroupCreated: BuildEventDefinition<
  typeof publicOnOperationGroupCreated
> &
  typeof publicOnOperationGroupCreated = createEventModule(
  publicOnOperationGroupCreated
);
/** */
export const onOperationGroupDeleted: BuildEventDefinition<
  typeof publicOnOperationGroupDeleted
> &
  typeof publicOnOperationGroupDeleted = createEventModule(
  publicOnOperationGroupDeleted
);
/** */
export const onOperationGroupUpdated: BuildEventDefinition<
  typeof publicOnOperationGroupUpdated
> &
  typeof publicOnOperationGroupUpdated = createEventModule(
  publicOnOperationGroupUpdated
);

export {
  WebhookIdentityType,
  SortOrder,
} from './restaurants-v1-operation-group-operation-groups.universal.js';
export {
  OperationGroup,
  ExtendedFields,
  Tags,
  TagList,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  CreateOperationGroupRequest,
  CreateOperationGroupResponse,
  GetOperationGroupRequest,
  GetOperationGroupResponse,
  UpdateOperationGroupRequest,
  UpdateOperationGroupResponse,
  DeleteOperationGroupRequest,
  DeleteOperationGroupResponse,
  QueryOperationGroupsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryOperationGroupsResponse,
  CursorPagingMetadata,
  Cursors,
  BulkCreateOperationGroupsRequest,
  BulkCreateOperationGroupsResponse,
  ItemMetadata,
  ApplicationError,
  BulkOperationGroupResult,
  BulkActionMetadata,
  BulkUpdateOperationGroupsRequest,
  MaskedOperationGroup,
  BulkUpdateOperationGroupsResponse,
  BulkUpdateOperationGroupsResponseBulkOperationGroupResult,
  BulkDeleteOperationGroupsRequest,
  BulkDeleteOperationGroupsResponse,
  BulkDeleteOperationGroupsResponseBulkOperationGroupResult,
  BulkUpdateOperationGroupTagsRequest,
  BulkUpdateOperationGroupTagsResponse,
  BulkUpdateOperationGroupTagsResult,
  BulkUpdateOperationGroupTagsByFilterRequest,
  BulkUpdateOperationGroupTagsByFilterResponse,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  OperationGroupCreatedEnvelope,
  OperationGroupDeletedEnvelope,
  OperationGroupUpdatedEnvelope,
  UpdateOperationGroup,
  OperationGroupsQueryResult,
  OperationGroupsQueryBuilder,
  OperationGroupQuerySpec,
  BulkCreateOperationGroupsOptions,
  BulkUpdateOperationGroupsOptions,
  BulkUpdateOperationGroupTagsOptions,
  BulkUpdateOperationGroupTagsByFilterOptions,
} from './restaurants-v1-operation-group-operation-groups.universal.js';
export { utils } from './restaurants-v1-operation-group-operation-groups.universal.js';
export {
  WebhookIdentityTypeWithLiterals,
  SortOrderWithLiterals,
  BulkUpdateOperationGroupTagsApplicationErrors,
  BulkUpdateOperationGroupTagsByFilterApplicationErrors,
  CommonQueryWithEntityContext,
  OperationGroupQuery,
} from './restaurants-v1-operation-group-operation-groups.universal.js';
